'use strict';

var Type = require('../type');

module.exports = new Type('tag:yaml.org,2002:map', {
  kind: 'mapping',
  construct: function (data) { return data !== null ? data : {}; }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/js-yaml/lib/js-yaml/type/map.js
// module id = kIJP
// module chunks = 0